import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import AutoNumeric from 'autonumeric';
import { GridOptions } from "ag-grid/main";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  CommonUtility,
  ReimbursementsSummary,
  WpPerson,
  WpReferral,
  AgGridUtility,
  Reimbursements,
  UPLOAD_BTN,
  DELETE_BTN,
  DOWNLOAD_BTN
} from '../shared';
import { DateUtility, ServerConstantsService, ReimbursementsDocs, Task } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import {
  DataService
} from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { Role } from "../shared/model/role.model";
import {PersonProvider} from "../shared/model/PersonProvider";
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import * as moment from 'moment';

@Component({
  selector: 'app-reimbursements',
  templateUrl: './reimbursements.component.html',
  styleUrls: ['./reimbursements.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ReimbursementsComponent implements OnInit, CanComponentDeactivate {

  myInputVariable: ElementRef;
  reimbursement: Reimbursements;
  reimbursementPrev: Reimbursements;
  autoNumeric: AutoNumeric;
  reimbursementsDocs: ReimbursementsDocs;
  reimbursementDocs: ReimbursementsDocs[] = [];
  serverReimbursements: Reimbursements;
  sortedReimbursement: Reimbursements;
  uploadReimbursement: Reimbursements;
  availableBalance: number;
  isAvailableBalance = '';
  reimbursements: Reimbursements[] = [];
  reimbursementsSummary: ReimbursementsSummary;
  reimbDecisionArray: any[];
  reimbDecisionMap: any;
  ServerConstants: any;
  errorFile: boolean = false;
  isProvider: boolean = false;
  isWpNew: boolean = false;
  displayVendorName: boolean = false;
  userActionNotificationsMap: any;
  refData: any;
  configName: string;
  sharedData: any;
  wpPersonId: string = '';
  private gridOptions: GridOptions;
  columnDefs: any;
  context: any;
  roles: Role[];
  isRRVisible: any;
  isRDVisible: any;
  minRDDate: NgbDateStruct;
  maxRDDate: NgbDateStruct;
  minSDDate: NgbDateStruct;
  maxSDDate: NgbDateStruct;
  today: Date = new Date();
  nonEditable: Boolean = false;
  saveExistingTask: Boolean = false;
  isNCDisabled:Boolean = false;
  errorMessage:Boolean = false;
  successMessage:Boolean = false;
  errorReasonCd:Boolean = false;
  isResetDisable: Boolean = false;
  isRRReasonDisable: Boolean = false;
  displayOldLabel: Boolean = false;
  reuimbursementReq: Boolean = false;
  ischangeDetected: boolean;
  reuimbursementDec: Boolean = false;
  invalidZipcodeFlag:Boolean;
  zipcodeErrorMessageField: string = null;
  reimbReasonMap: any;
  reimbReasonArray: any[];
  /*Files */
  selectedFiles: FileList;
  selectedFilesList: FileList;
  fileList: {
    file: any,
    progress: number,
    uploadedSw: boolean,
    size: any
  }[] = [];
  person: {
    id?: number
  };
  files: any[] = [];
  fileResponses: ReimbursementsDocs[] = [];
  wpPerson: WpPerson;
  referralId: string = '';
  providerId: string = '';
  task: Task;
  wpReferral: WpReferral;
  programCd;
  serviceCountyForPerson: number;
  providerForPerson: number;
  personProvider: PersonProvider;
  isNewReimbursement: boolean;
  uploadedFile = false;
  gridApi: any;
  tabToNextCell: any;
  tabIndex:any = "-1";
  isAddNew: Boolean = false;
  firstTime: Boolean = true;
  stateList: any[];
  paymentInfo: any[];
  invalidSsnFlag:Boolean;
  reimbursementCreatedDt: Date;
  cutoffDate: Date;
  showSsn: Boolean = true;
  ssnType = 'text';

  @ViewChild('payee') payee: ElementRef;
  @ViewChild('reason') reason: ElementRef;
  @ViewChild('requestedDt') requestedDt: ElementRef;
  @ViewChild('requestedAmt') requestedAmt: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;
  @ViewChild('submittedDt') submittedDt: ElementRef;
  @ViewChild('skillsGrid') skillsGrid: ElementRef;
  @ViewChild('headerText2') headerText2: ElementRef;
  @ViewChild('myInput') myInput: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('resetBtn') resetBtn: ElementRef;
  @ViewChild('payeeSsnTinField') payeeSsnTinField: ElementRef;

  centalOfficecounty: any;
  reimbBalanceArray: any;
  annualLimit: number;
  monthlyLimit: number;
  cutoffDt: string;
  otherReasonNotesSize: number = 0;
  rrReasonNotesSize: number = 0;
  reimbYear: number;
  serverObj: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    renderer: Renderer,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    private datePipe: DatePipe,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('RIMBS') == undefined){
      this.router.navigate(['/task']);
    }

       
    
    

  }

  ngOnInit() {
    this.dataService.globalAccess = true;
    this.gridOptions.rowHeight = 60;
    this.parseRefTableData();


    
    this.maxRDDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    this.sharedData = this.dataService.getSharedDataObject();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.providerId = this.sharedData.get('providerId');
    this.roles = this.sharedData.get('roles');
    this.personProvider = this.sharedData.get('personProvider');
    this.serviceCountyForPerson = this.personProvider.id.serviceCounty;
    this.providerForPerson = this.personProvider.id.providerId;
    this.userAccess();
    this.availableBalance = this.sharedData.get('availableBalance');
    console.log("this.availableBalance on page load==="+this.availableBalance);
    this.isAvailableBalance = this.sharedData.get('isAvailableBalance');
    console.log("this.isAvailableBalance on page load==="+this.isAvailableBalance);
    this.reimbursement = this.sharedData.get('reimbursement');
    this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    for (let balance of this.reimbBalanceArray) {
      if (balance.value === 'MB') {
        this.monthlyLimit = parseFloat(balance.name);
      }
      if (balance.value === 'AB') {
        this.annualLimit = parseFloat(balance.name);
        }
    }
    if(!this.isProvider && this.sharedData.get('reimbursement') !== null && this.sharedData.get('reimbursement') !== undefined && (this.reimbursement.decisionCd===null || this.reimbursement.decisionCd==="RP")) {
      if (this.isAvailableBalance === 'N' ) {
        this.notificationService.warn('Reimbursements', "The amount of the reimbursement exceeds the available balance.  Processing of this reimbursement may be delayed or denied due to the available balance.");
      }
      if (this.monthlyLimit < this.reimbursement.requestedAmount) {
                
        this.notificationService.warn('Reimbursements', "The monthly allowed amount is generally $"+this.monthlyLimit+" per month, not to exceed $"+this.annualLimit+" per Federal fiscal year.");
      }
    }
    if(this.isProvider && this.sharedData.get('reimbursement') !== null && this.sharedData.get('reimbursement') !== undefined && (this.reimbursement.decisionCd==="RR")) {
      if (this.isAvailableBalance === 'N' || this.availableBalance < this.reimbursement.requestedAmount) {
        this.notificationService.warn('Reimbursements', "The amount of the reimbursement exceeds the available balance.  Processing of this reimbursement may be delayed or denied due to the available balance.");
      }
      if (this.monthlyLimit < this.reimbursement.requestedAmount) {
                
        this.notificationService.warn('Reimbursements', "The monthly allowed amount is generally $"+this.monthlyLimit+" per month, not to exceed $"+this.annualLimit+" per Federal fiscal year.");
      }
    }

    if (this.sharedData.get('reimbursement') !== null && this.sharedData.get('reimbursement') !== undefined) {
      this.reimbursement = this.sharedData.get('reimbursement');
      this.reimbursementPrev = Object.assign({}, this.reimbursement);
    }

    if (this.reimbursement != null) { 
      
      this.isResetDisable = true;

      //Code to show the character count for Other Reason and Return for Revison Reason
      this.fileResponses = this.reimbursement.reimbursementsDocsId;
       if(this.reimbursement.reasonCd=='OT'){
      this.otherReasonNotesSize = this.reimbursement.otherReason.length;
      }
      if(this.reimbursement.decisionCd=='RR' || this.reimbursement.decisionCd=='RP'){
      this.rrReasonNotesSize = this.reimbursement.returnForRevisionReason.length;
      }

      if (this.fileResponses.length > 0) {
        for (let i = 0; i < this.fileResponses.length; i++) {
          this.reimbursementDocs.push(this.fileResponses[i]);
          var file = {
            name: this.fileResponses[i].fileName,
            fileLocation: this.fileResponses[i].fileLocation
          };
          this.fileList.push({
            file: file,
            progress: 0,
            uploadedSw: true,
            size: this.fileResponses[i].fileSize
          });
        }
      }
      this.reimbursement.submittedDt = this.dateUtility.convertDateFromServer(this.reimbursement.submittedDt);
      this.reimbursement.requestedDt = this.dateUtility.convertDateFromServer(this.reimbursement.requestedDt);
      this.reimbursement.authorizedDt =this.dateUtility.convertDateFromServer(this.reimbursement.authorizedDt);
      this.reimbursementPrev = Object.assign({}, this.reimbursement);
      this.isNewReimbursement = false;
      this.tabIndex = '0';
    } else {
      this.reimbursement = new Reimbursements();
      this.reimbursementPrev = new Reimbursements();
      this.fileResponses = this.reimbursement.reimbursementsDocsId;
      this.nonEditable = false;
      this.reimbursement.submittedDt = this.dateUtility.getSystemDateFromModel();
      if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
        this.reimbursement.personId = Number(this.sharedData.get('wpPersonId'));
        this.reimbursementPrev = Object.assign({}, this.reimbursement);
      }
      this.isNewReimbursement = true;
    }
    //console.log('fileslist', this.fileList)
    this.getColumnDefinitions();
    this.getCentralOfficeCounty();
 
    this.stateList = this.data.getValueFromSharedDataMap('STATE'); 

    console.log('Current Date: ' +  Date.now().toString());
    console.log('this.reimbursement.decisionCd :' + this.reimbursement.decisionCd);
    console.log('this.reimbursement.processStartSw :' + this.reimbursement.processStartSw);
    
    
    this.SetReimbursementConfigDate();

    this.route.queryParams.subscribe(params => {
      const receivedData = params['isNewRequest']; // Get the 'id' parameter
      console.log("receivedData==="+receivedData);
      // Use the 'id' in your component
        const isNewReq = receivedData === 'true';
      console.log("this.isWpNewRequest==="+isNewReq);
      if(!this.isProvider && isNewReq ) {
       this.isWpNew=true;
      }
      });
 

    if(this.isProvider) {
      if (this.reimbursement.createdDt != null || this.reimbursement.createdDt != undefined) {
        this.nonEditable=true;
      }  
      else {
        this.nonEditable=false;
      }    
    }
    
    else {
      if(this.isWpNew && !this.isProvider) {
        this.nonEditable=false;
      }
      else{
      this.nonEditable=true;
      }
    }

    if (this.reimbursement != null) {
      this.saveExistingTask = true;
      if(this.reimbursement.decisionCd=='RR') {
        this.isResetDisable = false;
        if(this.isProvider){
          this.nonEditable=false;
        }
        else{
          this.nonEditable=true;
          this.isResetDisable = true;
          this.isRRReasonDisable=true;
        }
      }
      //code when the decision code is RP - mask the fields on provider
      else if(this.reimbursement.decisionCd=='RP') {
       if(this.isProvider){
          this.nonEditable=true;
          this.isResetDisable = true;
        }
        else{
          this.isResetDisable = false;
        }
      }
      else if(this.reimbursement.decisionCd=='BE' && (this.reimbursement.processStartSw == null || this.reimbursement.processStartSw == undefined)) {
        this.isResetDisable = false;
      }
      else {
        this.isResetDisable = true;
      }      
    }
    
    
    this.reimbursementCreatedDt =  this.reimbursement.createdDt as Date;  
    //this.cutoffDate = new Date(2023, 8, 28);
    this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    for (let date of this.reimbBalanceArray) {
      if (date.value === 'CD') {
        this.cutoffDate = new Date(date.name);
      }
    }
    this.cutoffDt = this.datePipe.transform(this.cutoffDate, 'yyyy/MM/ddTHH:mm:ss');
    console.log("formattedDate cutoff=====" + this.cutoffDt);
// Compare the two date
if (this.reimbursementCreatedDt.toString() > this.cutoffDt) {
  this.displayOldLabel = false;
} else {
  this.displayOldLabel = true;
}
    // if(this.dateUtility.compareDate(this.cutoffDate, this.reimbursementCreatedDt) === 1)    {
    //   console.log("if");
    //   this.displayOldLabel = true;
    // } else  {
    //   console.log("else");
    //   this.displayOldLabel = true;
    // }
    
    console.log("created date=====" + this.reimbursement.createdDt);
    console.log("displayOldLabel=====" + this.displayOldLabel);
    console.log("decisionCd=====" + this.reimbursement.decisionCd);
    console.log("saveExistingTask=====" + this.saveExistingTask);
    console.log("isResetDisable=====" + this.isResetDisable);
    console.log("nonEditable=====" + this.nonEditable); 
    console.log("auth date=====" + this.reimbursement.authorizedDt);  

  }

  // TO Get the Central Office county
  getCentralOfficeCounty() {
    const countyCds = this.data.getValueFromSharedDataMap('COUNTIES');
    for (const county of countyCds) {
      if (county.name === 'Central Office') {
        this.centalOfficecounty = county.value;
        break;
      }
    }
    console.log(this.centalOfficecounty);
  }

  dataChange() {
    this.isResetDisable = false;
  }
  decisionChange() {
    this.isResetDisable = false;
    
    if (this.reimbursement.decisionCd == 'RR' ) {
         this.reimbursement.authorizedAmount=null;
    }

    if (this.reimbursement.decisionCd === 'BE') {
      this.reimbursement.authorizedAmount = this.reimbursement.requestedAmount;
    }
    // 
     if (this.reimbursement.decisionCd === 'TE') {
     this.reimbursement.authorizedAmount = "0.00";
    }
    this.reimbursementPrev = Object.assign({}, this.reimbursement);
  }
  changeDetection() {
    this.ischangeDetected = true;
    // if(this.reimbursement.decisionCd != 'RR') {
    //   this.reimbursement.returnForRevisionReason='';
    // }
    if(this.reimbursement.reasonCd != 'OT') {
      this.reimbursement.otherReason='';
    }
    
  }
  SetReimbursementConfigDate(){
console.log('Value of requestedDt:'+ this.reimbursement.requestedDt);
const dateStr = this.reimbursement.requestedDt.date;
const year = this.reimbursement.requestedDt.year;
const month = this.reimbursement.requestedDt.month;
const day = this.reimbursement.requestedDt.day;
// Check if the date information is valid
if (typeof year === 'number' && typeof month === 'number' && typeof day === 'number') {
const reimbDateSelected = new Date(year, month-1, day); 
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
// Check if reimbDateSelected is between Oct 1st of last year to Sep 30th of current year
const octLastYear = new Date(currentYear - 1, 9, 1);
const sepCurrentYear = new Date(currentYear, 8, 30);
// Check if reimbDateSelected is between Oct 1st of last year to Sep 30th of current year
if (reimbDateSelected >= octLastYear && reimbDateSelected  <= sepCurrentYear) {
  this.reimbYear = currentYear;
} else {
  const octCurrentYear = new Date(currentYear, 9, 1); // October 1 of current year
  const sepNextYear = new Date(currentYear + 1, 8, 30); // September 30 of next year
  const octLastBeforeYear = new Date(currentYear - 2, 9, 1); // October 1 of last year
  const sepLastYear = new Date(currentYear - 1, 8, 30); 

  // Check if reimbDateSelected is between Oct 1st of current year to Sep 30th of next year
  if ( reimbDateSelected  >= octCurrentYear && reimbDateSelected <= sepNextYear) {
    this.reimbYear = currentYear + 1;
  }
  // Check if reimbDateSelected is between Oct 1st of Last before year to Sep 30th of Last year 
  else if ( reimbDateSelected  >= octLastBeforeYear && reimbDateSelected <= sepLastYear) {
    this.reimbYear = currentYear - 1;
  }
  else{
    this.reimbYear =undefined;
  }
}
}
if(this.reimbYear==undefined){
 // this.paymentInfo = this.data.getValueFromSharedDataMap('AASIS_PAYMENT_INFO'); 
  this.configName='AASIS_PAYMENT_INFO';
}
else{
  this.configName='AASIS_PAYMENT_INFO'+'_'+this.reimbYear;
}
console.log("this.configName===="+this.configName);
this.http.post<any>(this.ServerConstants.SERVER_API_URL + '/staticData/find', {
  name: this.configName,
  type: 'DD'
}).subscribe((val) => {
    this.serverObj = val;
    if (val.dataValue !== undefined && val.dataValue.EN !== undefined) {
      val.dataValue.EN.forEach((config)=>{
        if(config.activeBeginDt!==null && config.activeBeginDt!==undefined){
          if(config.value == 'VN'){
            this.reimbursement.payeeVendorNumber = config.name;
           } else if(config.value == 'CC'){
             this.reimbursement.costCenter = config.name;
           } else if(config.value == 'IO'){
             this.reimbursement.internalOrder = config.name;
           } else if(config.value == 'GLC'){
             this.reimbursement.generalLedgerCode = config.name;
            }
            else if(config.value == 'BA'){
              this.reimbursement.businessArea = config.name;
            } else if(config.value == 'WBS'){
             if(config.name=='NA'){
               this.reimbursement.wbs =null;
             }
             else{
               this.reimbursement.wbs = config.name;
             }
             
           }
        }
       
      })
      }
  },
  response => {
    this.notificationService.error('Admin', this.userActionNotificationsMap.ERROR);
  },
  () => {

  });

  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.ischangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };
  focusing(){
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
  }

  onClick() {
    if (this.ssnType === 'password') {
      this.ssnType = 'text';
      this.showSsn = true;
    } else {
      this.ssnType = 'password';
      this.showSsn = false;
    }
  }

  save() {
    this.ischangeDetected = false;
    this.modalPopupService.setChangeDetected(false);
    if (this.reimbursementDocs.length > 0) {
      this.errorFile = false;

      this.reimbursement.reimbursementsDocsId = this.reimbursementDocs;
      if (this.reimbursement.requestedAmount != undefined) {
        var ramount = this.reimbursement.requestedAmount.toString();
        if (ramount.split("$")[1] != undefined) {
          this.reimbursement.requestedAmount = ramount.split("$")[1];
        }
      }
      this.serverReimbursements = this.reimbursement;
      let copyReimbursement = Object.assign({}, this.serverReimbursements);
      copyReimbursement.submittedDt = this.dateUtility.convertDateForServer(this.reimbursement.submittedDt);
      copyReimbursement.requestedDt = this.dateUtility.convertDateForServer(this.reimbursement.requestedDt);
      if(this.reimbursement.decisionCd === 'BE') {
        copyReimbursement.status = "Pending";
        copyReimbursement.authorizedDt = this.dateUtility.convertDateForServer( this.dateUtility.getSystemDateFromModel());
      
      } else if(this.reimbursement.decisionCd === 'TE') {
        copyReimbursement.status = "Denied";
        copyReimbursement.processStartSw="D";
        copyReimbursement.authorizedDt = this.dateUtility.convertDateForServer(this.dateUtility.getSystemDateFromModel());
      
      } else {
        copyReimbursement.status = "";
        copyReimbursement.authorizedDt =null;
        copyReimbursement.authorizedAmount=null;
      }

      // this.paymentInfo = this.data.getValueFromSharedDataMap('AASIS_PAYMENT_INFO'); 
      // console.log('load payment info ' + this.paymentInfo.length);
  
      // for(let i=0; i<this.paymentInfo.length; i++){      
      //   if(this.paymentInfo[i].value == 'BA'){
      //     this.reimbursement.businessArea = this.paymentInfo[i].name;
      //   }
      // }
      //Code to set the decisionCd to RP once the provider acts on RR tasks and click save -RP is a just a backend decision code to mask the fields on provider
      if(this.reimbursement.decisionCd === 'RR' && this.isProvider){
        copyReimbursement.decisionCd='RP';
        
      }
      
     
      copyReimbursement.businessArea=this.reimbursement.businessArea;
      copyReimbursement.returnForRevisionReason=this.reimbursement.returnForRevisionReason
      this.http.post<Reimbursements>(this.ServerConstants.REIM_SERVER_API + '/reimbursements/save', copyReimbursement)
        .subscribe(
          (res: Reimbursements) => {
            if (res.hasOwnProperty('errorCode')) {
              this.notificationService.error('Reimbursements ', this.userActionNotificationsMap.ERROR);
              setTimeout(() => this.payee.nativeElement.focus(), 0);
              this.payee.nativeElement.click();
            } else {
              this.CreateTask(res.id);
              if(this.reimbursement.decisionCd != null || this.reimbursement.decisionCd != undefined){
                this.createAlert();
              }
              this.router.navigate(['task/reimbursementsSummary']);
              this.notificationService.success('Reimbursements ', this.userActionNotificationsMap.UPDATE);
              // this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
              //   for (let balance of this.reimbBalanceArray) {
              //     if (balance.value === 'AB') {
              //       this.annualLimit = parseFloat(balance.name);
              //     }
              //     if (balance.value === 'MB') {
              //       this.monthlyLimit = parseFloat(balance.name);
              //     }
              //   }
              // console.log("this.availableBalance before===="+this.availableBalance);
              // console.log("res.requestedAmount before===="+res.requestedAmount);
              // console.log("this.isAvailableBalance before===="+this.isAvailableBalance);
              // console.log("this.reimbursement.decisionCd before===="+this.reimbursement.decisionCd);
              // // if(!this.isProvider){
              //   console.log("Inside worker===");

              //   // if(this.isAvailableBalance === 'N'){
              //   //   this.finalavailableBalance=-(res.requestedAmount+this.availableBalance);
              //   // }
              //   // else{
              //   //   if(this.isWpNew){
              //   //     this.finalavailableBalance=this.availableBalance;
              //   //   }
              //   //   else{
              //   //    this.finalavailableBalance=res.requestedAmount+this.availableBalance;
              //   //   }
              //   // }
              //   // console.log("this.finalavailableBalance===="+this.finalavailableBalance);
              //   if (this.isAvailableBalance === 'N') {
              //     this.notificationService.warn('Reimbursements', "The amount of the reimbursement exceeds the available balance.  Processing of this reimbursement may be delayed or denied due to the available balance.");
              //   }

              // }
              // if(this.isProvider){
              //   console.log("Inside provider===");
              //   if (this.availableBalance < res.requestedAmount
              //     || this.isAvailableBalance === 'N') {
              //     this.notificationService.warn('Reimbursements', "The amount of the reimbursement exceeds the available balance.  Processing of this reimbursement may be delayed or denied due to the available balance.");
              //   }
              // }
              
              // if (this.monthlyLimit < res.requestedAmount) {
                
              //   this.notificationService.warn('Reimbursements', "The monthly allowed amount is generally $"+this.monthlyLimit+" per month, not to exceed $"+this.annualLimit+" per Federal fiscal year.");
              // }
              setTimeout(() => this.headerText.nativeElement.focus(), 0);
              this.headerText.nativeElement.click();
            }
          },
          (response) => {
            this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
            setTimeout(() => this.payee.nativeElement.focus(), 0);
            this.payee.nativeElement.click();
          },
          () => {
          });
    } else {
      this.errorFile = true;
      // US# 19_01 | Story ID	19_01 | Story Title		Work Requirement - Yellow Toast Notifications | POIGAI
      // the existing yellow toast notification to be changed to red.
      this.notificationService.error('Reimbursements', "Please choose at least one attachment");
    }
  }

  CreateTask(id) {
    this.task = new Task();
    let today = new Date();
    let dueDate = new Date();
    console.log("revision decisionCd " + this.reimbursement.decisionCd);

    // dueDate.setDate( dueDate.getDate() +10);
    /*if (this.sharedData.get('taskId') != undefined) {
      this.task.id = parseInt(this.sharedData.get('taskId'));
      this.dataService.removeValueFromSharedDataMap('taskId');
    } else {*/
      this.wpPerson = new WpPerson();
      this.wpPerson.id = parseInt(this.sharedData.get('wpPersonId'));
      this.wpReferral = new WpReferral();
      this.wpReferral.id= this.sharedData.get('referralId');
      this.task.wpPerson = this.wpPerson;
      this.task.wpReferral = this.wpReferral;
      this.task.taskStartDt = this.dateUtility.convertObjectDateForServer(today);
      this.task.programCd = "FS";
      this.task.parentTaskId = id;
      this.personProvider = this.sharedData.get('personProvider');
      this.serviceCountyForPerson = this.personProvider.id.serviceCounty;
      if(this.reuimbursementReq){
        this.task.assignedToInd = "C";
        this.task.assignedTo = this.centalOfficecounty + "";
       // this.task.assignedTo = this.serviceCountyForPerson + "";
        this.task.taskType = "RQ";
        this.task.taskStatus = "OP";
        this.saveOpenTask();

         //code to close RE task once updated and click save on Provider portal 
         console.log("this.reuimbursementDec RR" + this.reuimbursementDec);
         if(this.reimbursement.decisionCd == 'RR'){
          this.task.assignedToInd = "P";
         this.task.assignedTo = this.providerForPerson + "";
         this.task.taskType = "RE";
         //this.reimbursement.decisionCd=null;
         this.closeOpenTask();
         }
      }

      if(this.reuimbursementDec){

        console.log("this.reuimbursementDec " + this.reuimbursementDec);
        console.log("this.reimbursement.decisionCd " + this.reimbursement.decisionCd);

        this.task.assignedToInd = "C";
        this.task.assignedTo = this.centalOfficecounty + "";
        //this.task.assignedTo = this.serviceCountyForPerson + "";
        this.task.taskType = "RQ";
        this.closeOpenTask();

        this.task.assignedToInd = "P";
        this.task.assignedTo = this.providerForPerson + "";
        if(this.reimbursement.decisionCd == 'RR'){
          this.task.taskType = "RE";
        } else {
          this.task.taskType = "RA";
        }
        
        this.task.taskStatus = "OP";
        this.saveOpenTask();
      }
    //}
  }

  saveOpenTask(){
    this.http.post<Task>(this.ServerConstants.SERVER_API_URL + "/taskManagement/createTask", this.task).subscribe(
      (val:Task) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
        }
        else {
          this.task = val;
          if (this.task.id != null) {
            this.notificationService.success('Reimbursements Task Created', this.userActionNotificationsMap.UPDATE);
          }
        }
      },
      response => {
        this.notificationService.error('Create Task', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  closeOpenTask(){
    this.http.post<Task>(this.ServerConstants.SERVER_API_URL + "/taskManagement/closeTask", this.task).subscribe(
      (val) => {
        if (val == null || val.hasOwnProperty('errorCode')) {
          this.notificationService.error('Close Task', this.userActionNotificationsMap.ERROR);
        }
        else {
          //this.notificationService.success('Close Task', this.userActionNotificationsMap.UPDATE);
        }
      },
      response => {
        //this.notificationService.error('Reimbursements Task Closed', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });
  }

  parseRefTableData() {
    this.reimbReasonArray = this.data.getValueFromSharedDataMap("ReimbReasonDesc");
    this.reimbReasonMap = this.commonUtil.createNativeMapFromList(this.reimbReasonArray);
    this.reimbDecisionArray = this.data.getValueFromSharedDataMap("ReimbDecisionDesc");
    this.reimbDecisionMap = this.commonUtil.createNativeMapFromList(this.reimbDecisionArray);
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap("USER-ACTION-NOTIFICATIONS"));
  }

  userAccess() {
    for (const role of this.roles) {
      if (role.id === 4) {
        this.isRRVisible = true;
        this.isRDVisible = true;
        this.nonEditable = false;
        this.isProvider = false;
        this.reuimbursementDec = true;
        this.reuimbursementReq = false;
      }
      else if (role.id == 5) {
        this.nonEditable = true;
        this.isRRVisible = true;
        this.isRDVisible = false;
        this.isProvider = true;
        this.reuimbursementReq = true;
        this.reuimbursementDec = false;
      }

    }
  }
  selectFile(event) {
    this.errorFile = false;
    this.firstTime = false;
    this.isAddNew = true;
    if(!this.uploadedFile){
      this.fileList = [];
    }
    this.selectedFiles = event.target.files;
    if (this.selectedFiles.length > 0) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        let blob = this.selectedFiles[i];
        let fileReader = new FileReader();
        fileReader.onloadend = function(e:any) {
          //const that = params.context.component;
          var arr = (new Uint8Array(<ArrayBuffer> e.target.result)).subarray(0, 4);
          var header = "";
          for(var i = 0; i < arr.length; i++) {
             header += arr[i].toString(16);
          };

          if(['FFD8','8950','2550','D0CF'].indexOf(header.substring(0,4)) > -1){
            localStorage.setItem('fileValidation','true');
          }
          else{
            localStorage.setItem('fileValidation','false');
          }
        };
        fileReader.readAsArrayBuffer(blob);
        setTimeout(()=>{
          if(localStorage.getItem('fileValidation') === 'true'){
            this.fileList.push({
              file: this.selectedFiles.item(i),
              progress: 0,
              uploadedSw: false,
              size: (this.selectedFiles.item(i).size / (1024 * 1024)).toFixed(7)
            });
            if (this.gridOptions.api) {
              this.gridOptions.api.setRowData(this.fileList);
              this.setDisplayedRowAtAddNew();
            }
          }
          else{
            this.notificationService.error('System Error:Please contact Help Desk', 'File type not supported');
          }
        },1000)
        
      }
      
    } else {
      this.errorFile = true;
    }
  }

  removeFile(file, i, params) {
    let that = params.context.component;
    that.fileList.splice(i, 1);
    that.gridOptions.api.setRowData(that.fileList);
    /*params.api.setRowData(this.gridOptions.rowData);
    const rmFiles = document.getElementById("rmFile");
    this.myInputVariable.nativeElement.value = "";
    console.log(this.myInputVariable.nativeElement.value);*/
  }

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'File Name',
        field: 'file.name',
        cellstyle: {verticalAlign: 'center'},

        //cellClass: 'rm-grid-top'
      },
      {
        headerName: 'Size',
        width: 100,
        cellRenderer: this.getFileSize,
        //cellClass: 'rm-grid-top'
      },
      {
        headerName: 'Progress',
        width: 100,
        field: 'progress',
        cellRenderer: this.getProgressBar
      },
      {
        headerName: 'Action',
        width: 100,
        field: '',
        cellRenderer: this.getEditButton,
        cellClass: 'rm-grid-upload rm-grid-upload',
        suppressFilter: true,
        suppressSorting: true,
      }
    ];


    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  
  onGridReady(params) {
    /*this.gridApi = params.api;

    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();

    this.gridOptions.rowClass = 'rm-grid-row';*/

    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    this.gridOptions.rowHeight = 55;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
    this.gridOptions.rowClass = 'rm-grid-row';
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  getFileSize(params) {
    return '' + params.data.size + ' MB';
  }

  getProgressBar(params) {
    const that = params.context.component;
    const divRow = document.createElement('div');
    divRow.setAttribute("class", "progress rm-grid-progress");
    const divCol1 = document.createElement('div');
    divCol1.setAttribute("id", "progress" + params.rowIndex);
    divCol1.setAttribute("class", "progress-bar progress-bar-info progress-bar-striped");
    if (params.data.uploadedSw) {
      divCol1.setAttribute("style", "width: 100%");
      const content = document.createTextNode("100%");
      divCol1.appendChild(content);
    } else {
      const content = document.createTextNode("0%");
      divCol1.appendChild(content);
    }
    divRow.appendChild(divCol1);
    return divRow;
  }


  alphaCharsOnly(event): boolean {    
    const charCode = (event.which) ? event.which : event.keyCode;
    
    if ((charCode >= 97 && charCode  <= 122) || (charCode >= 65 && charCode  <= 90) || charCode == 39 || charCode == 32) {
      return true;
    }
    return false;

  }
  alphaCharsNumbersOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
  
    if (
      (charCode >= 97 && charCode <= 122) || // lowercase letters
      (charCode >= 65 && charCode <= 90) ||  // uppercase letters
      (charCode >= 48 && charCode <= 57) ||  // numbers
      charCode === 32  // space
    ) {
      return true;
    } else if (charCode > 31) {
      return false;
    }
    return true; // Allow control characters (e.g., Backspace, Enter)
  }
  
  currencyInputChanged(value) {
    //console.log(value);
    var  num  =  value;
    //console.log(num);
    if (num.length >= 4) {
    }
    return  Number(num);
  }

  getEditButton(params) {
    const that = params.context.component;
    //console.log(params);
    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row justify-content-center");

    const uploadElement = document.createElement('a');
    const uploadImage = UPLOAD_BTN;
    uploadElement.innerHTML = uploadImage;
    uploadElement.setAttribute("id", "uploadFile" + params.rowIndex);

    const removeElement = document.createElement('a');
    const removeImage = DELETE_BTN;
    removeElement.innerHTML = removeImage;
    removeElement.setAttribute("id", "removeFile" + params.rowIndex);

    const downloadElement = document.createElement('a');
    downloadElement.innerHTML = DOWNLOAD_BTN;
    downloadElement.setAttribute("id", "downloadFile" + params.rowIndex);

    if (params.data.uploadedSw) {
      downloadElement.addEventListener('click', () => {
        that.downloadFile(params.data.file);
      });
      downloadElement.addEventListener('keydown', (event) => {
        if (event.keyCode === 13 || event.keyCode === 32){
          that.downloadFile(params.data.file);
          event.preventDefault();
        } else if (event.keyCode === 9) {
          //event.preventDefault();
        }
      });
      downloadElement.setAttribute('tabindex', '0');

      const divCol1 = document.createElement('div');
      divCol1.setAttribute('class', 'col-1 right-margin-1');
      divCol1.appendChild(downloadElement);
      divRow.appendChild(divCol1);
    } else {
      uploadElement.addEventListener('click', () => {
        console.log(params.data.file);
        that.uploadFile(params.data.file, params);
        setTimeout(() => removeElement.focus(), 0);
      });
      uploadElement.addEventListener('keydown', (event) => {
        if(event.keyCode === 13 || event.keyCode === 32){
          that.uploadFile(params.data.file, params);
          setTimeout(() => removeElement.focus(), 0);
        }
        else if(event.keyCode == 9){
          event.preventDefault();
          setTimeout(() => removeElement.focus(), 0);
        }
      });
      uploadElement.setAttribute("tabindex", "0");

      removeElement.addEventListener('click', () => {
        //console.log(params);
        that.removeFile(params.data, params.rowIndex, params);
        setTimeout(() => removeElement.focus(), 0);
      });
      removeElement.addEventListener('keydown', (event) => {
        if(event.keyCode === 13 || event.keyCode === 32) {
          that.removeFile(params.data, params.rowIndex, params);
          setTimeout(() => removeElement.focus(), 0);
        }
      });
      removeElement.setAttribute("tabindex", "0");

      const divCol1 = document.createElement('div');
      divCol1.setAttribute("class", "col-1 right-margin-1");
      divCol1.appendChild(uploadElement);

      const divCol2 = document.createElement('div');
      divCol2.setAttribute("class", "col-1");
      divCol2.appendChild(removeElement);

      divRow.appendChild(divCol1);
      divRow.appendChild(divCol2);
    }
    divRow.setAttribute("tabindex", "0" );
    return divRow;
  }
  uploadFile(file, params) {
    console.log(file);
    console.log(params);
    file.progress = 0;
    let formdata: FormData = new FormData();

    formdata.append('file', file);
    formdata.append('personId', new Blob([JSON.stringify(this.reimbursement.personId)], { type: 'application/json' }));
    formdata.append('fileSize', new Blob([JSON.stringify(params.data.size)], { type: 'application/json' }));
    console.log(formdata);
    this.http.post<ReimbursementsDocs>(this.ServerConstants.REIM_SERVER_API + '/reimbursements/upload', formdata)
      .subscribe(
        (res: ReimbursementsDocs) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Reimbursements ', this.userActionNotificationsMap.ERROR);
          } else {
            this.reimbursementsDocs = res;
            this.reimbursementDocs.push(this.reimbursementsDocs);
            const uploadElement = document.getElementById("uploadFile" + params.rowIndex);
            const uploadIcon = uploadElement.children.item(0);
            uploadElement.setAttribute("style", "color:gray; cursor: not-allowed; pointer-events: none");
            uploadIcon.setAttribute("style", "color:gray; cursor: not-allowed; pointer-events: none");
            const removeElement = document.getElementById("removeFile" + params.rowIndex);
            const removeIcon = removeElement.children.item(0);
            removeElement.setAttribute("style", " color:gray;cursor: not-allowed; pointer-events: none");
            removeIcon.setAttribute("style", " color:gray;cursor: not-allowed; pointer-events: none");
            const progressElement = document.getElementById("progress" + params.rowIndex);
            progressElement.setAttribute("style", "width: 100%");
            const content = document.createTextNode("100%");
            progressElement.removeChild(progressElement.firstChild);

            progressElement.appendChild(content);
            this.fileList[params.rowIndex].uploadedSw = true;
            this.uploadedFile = true;
            this.notificationService.success('File uploaded successfully', '');
          }
        },
        (response) => {
          this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });

  }

  reset() {
    if (this.reimbursement.id !== null && this.reimbursement.id !== undefined) {
      this.reimbursement.vendorName = this.reimbursementPrev.vendorName;
      this.reimbursement.reasonCd = this.reimbursementPrev.reasonCd;
      this.reimbursement.requestedDt = this.reimbursementPrev.requestedDt;
      this.reimbursement.requestedAmount = this.reimbursementPrev.requestedAmount;
      this.reimbursement.decisionCd = this.reimbursementPrev.decisionCd;
    } else {
      this.reimbursement = new Reimbursements();
      this.reimbursement.submittedDt = this.dateUtility.getSystemDateFromModel();

    }
  }

  focusPayee(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.payee.nativeElement.focus(), 0);
      // this.payee.nativeElement.click();
    }
  }

  focusReason(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.reason.nativeElement.focus(), 0);
    } else if (e.keyCode === 9  && e.shiftKey) {
      setTimeout(() => this.headerText2.nativeElement.focus(), 0);
    }
  }

  focusRequestedDt(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.requestedDt.nativeElement.focus(), 0);
    }
  }

  focusRequestedAmt(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.requestedAmt.nativeElement.focus(), 0);
      // this.payee.nativeElement.click();
    } else if (e.keyCode === 9  && e.shiftKey) {
      setTimeout(() => this.submittedDt.nativeElement.focus(), 0);
      this.submittedDt.nativeElement.click();
    }
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9  && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    } else if (e.keyCode === 9  && e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
    }
  }

  focusReset(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
    }
  }

  focusSave(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.saveBtn.nativeElement.focus(), 0);
    } else if (e.keyCode === 9  && e.shiftKey) {
      setTimeout(() => this.skillsGrid.nativeElement.focus(), 0);
    }
  }

  focusRequestedDate(e: KeyboardEvent) {
    if (e.keyCode === 9  && e.shiftKey) {
      setTimeout(() => this.requestedDt.nativeElement.focus(), 0);
    }
  }

  focusPayeeShiftTab(e: KeyboardEvent) {
    if (e.keyCode === 9  && e.shiftKey) {
      setTimeout(() => this.payee.nativeElement.focus(), 0);
    }
  }

  focusNextFromAmount(e: KeyboardEvent) {
    if ( this.isNewReimbursement) {
      if (e.keyCode === 9  && e.shiftKey) {
        setTimeout(() => this.myInput.nativeElement.focus(), 0);
      }
    } else {
      this.focusSummary(e);
    }
  }

  focusSummary(e) {
    this.isAddNew = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.fileList.length === 0) {
      return;
    }

    if(event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }


  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  setDisplayedRowAtAddNew() {

    var index = this.fileList.length - 1;
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }


  onPaginationChanged(){
    if (this.gridApi ) {
      if (this.isAddNew) {
        return;
      } else if( this.firstTime ){
        return;
      } else{
        this.setDisplayedRowAtIndex();
      }
    }
  }

  
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  validateZipCode(str) 
{
  console.log("validateZipCode========");
  console.log("str==="+str);
  if (/^\d{5}(-\d{4})?$/.test(str) || str==="" || str===undefined) 
  {
    this.invalidZipcodeFlag = false;
   this.zipcodeErrorMessageField = "";
    console.log("zipcodeErrorMessageField==="+this.zipcodeErrorMessageField);
    return true;

  } else {
    this.invalidZipcodeFlag = true;
    this.zipcodeErrorMessageField = "Zip Code requires 5 numeric characters ";
    console.log("zipcodeErrorMessageField error==="+this.zipcodeErrorMessageField);
    return false;

  }
  
}

  downloadFile(file) {
    this.getDocument(file)
      .subscribe(
        (res: any) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Reimbursements ', this.userActionNotificationsMap.ERROR);
          } else {
            console.log(res.data);
            if(window.navigator.msSaveOrOpenBlob) {
              //msSaveBlob only available for IE & Edge
              window.navigator.msSaveBlob(res.data,res.filename);
            }
            else{
              const url = window.URL.createObjectURL(res.data);
              console.log(url);
              const a = document.createElement('a');
              document.body.appendChild(a);
              a.setAttribute('style', 'display: none');
              a.href = url;
              a.download = res.filename;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove();
            }
            
          }
        },
        (response) => {
          if (response.status === 404) {
            this.notificationService.error(this.userActionNotificationsMap.ERROR, 'File Not Found');
          } else {
            this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
          }
        },
        () => {
        });
  }

  // setPayeeType(event: any) {
  //   this.reimbursement.payeeType = event.target.value;
  //   console.log("Payee Type =====" + this.reimbursement.payeeType);
   
  //   if(this.reimbursement.payeeType === 'VN' || this.reimbursement.payeeType === 'IN') {      
  //     this.resetPayeeInfo();
  //   }  
  // }

  resetPayeeInfo(){    
    this.reimbursement.vendorName = '';      
    this.reimbursement.payeeFirstName = '';  
    this.reimbursement.payeeLastName = '';  
    this.reimbursement.payeeSsnTin = '';  
    this.reimbursement.payeeAddress = '';  
    this.reimbursement.payeeCity = '';  
    this.reimbursement.payeeState = '';  
    this.reimbursement.payeeZip = '';  
    this.ssnType='text';
    this.showSsn=true;
  }

  getDocument(file: any): Observable<any> {
    const token = this.dataService.getSharedDataObject().get('token');
    return this.http.post<any>(this.ServerConstants.REIM_SERVER_API + '/reimbursements/downloadFile',  file.fileLocation, {
      headers: {'Authorization': 'Bearer ' + token},
      responseType: 'blob' as 'json'
    })
      .map(res => {
        console.log(res);
        return {
          filename: file.name,
          data: res
        };
      });
  }

  public otherReasonOnQuickTextChanged($event) {
    this.otherReasonNotesSize = this.reimbursement.otherReason.length;
  }
  public rrReasonOnQuickTextChanged($event) {
    this.rrReasonNotesSize = this.reimbursement.returnForRevisionReason.length;
  }

  isValidSSN(str) {  
    const regex = /^(?!(000|666|9))(\d{3}-?(?!(00))\d{2}-?(?!(0000))\d{4})$/;             
    console.log("isValidSSN ===================" + str + " " + regex.test(str));
    // Return true if the str
    // matched the ReGex
    if (regex.test(str)) {   
        this.invalidSsnFlag = false;
        this.ssnType='password';
        this.showSsn=false;
        this.payeeSsnTinField.nativeElement.classList.remove('ng-invalid');
        this.payeeSsnTinField.nativeElement.classList.add('ng-valid');     
        console.log("invalidSsnFlag ===================" + this.invalidSsnFlag);  
        return true;
    }
    else {
        this.invalidSsnFlag = true;
        this.ssnType='text';
        this.showSsn=true;
        this.payeeSsnTinField.nativeElement.classList.remove('ng-valid');
        this.payeeSsnTinField.nativeElement.classList.add('ng-invalid');
        console.log("invalidSsnFlag ===================" + this.invalidSsnFlag);
        return false;
    }    
    
}
validateRequestedAmount() { 
  this.availableBalance = this.sharedData.get('availableBalance');
  this.isAvailableBalance = this.sharedData.get('isAvailableBalance');
  this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    for (let balance of this.reimbBalanceArray) {
      if (balance.value === 'MB') {
        this.monthlyLimit = parseFloat(balance.name);
      }
      if (balance.value === 'AB') {
             this.annualLimit = parseFloat(balance.name);
             }
    }
    if (this.isAvailableBalance === 'N' || this.availableBalance < this.reimbursement.requestedAmount) {
    this.notificationService.warn('Reimbursements', "The amount of the reimbursement exceeds the available balance.  Processing of this reimbursement may be delayed or denied due to the available balance.");
  }
  if (this.monthlyLimit < this.reimbursement.requestedAmount) {
            
    this.notificationService.warn('Reimbursements', "The monthly allowed amount is generally $"+this.monthlyLimit+" per month, not to exceed $"+this.annualLimit+" per Federal fiscal year.");
  }
  
}

restrictSpecial(event){
  if((/[<>{}-]/.test(event.key))){
    event.returnValue = false;
    return;
   }
    event.returnValue = true;
}

  createAlert(){
    let requestArray=[];
      let request = {
        createdBy: sessionStorage.getItem("FirstName"),
        description:"Your Reimbursement request has been " + this.data.getValueFromSharedDataMap("ReimbDecisionDesc").find(obj => obj.value == this.reimbursement.decisionCd).name + " for $" + this.reimbursement.authorizedAmount,
        personId:Number(this.sharedData.get('wpPersonId'))
      }
      requestArray.push(request);
    this.http.post(this.ServerConstants.CITIZEN_API_URL+"/alerts/save",requestArray).subscribe((data)=>{
      if(data["message"]=="success"){
        this.notificationService.success('Reimbursements', "Alert Created for Citizen");
      }
      else{
        this.notificationService.error('Reimbursements', "Unable to create alert for citizen");
      }
    },error=>{
      this.notificationService.error('Reimbursements', "Unable to create alert for citizen");
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/reimbursements/reimbursements.component.ts